import { AxiosResponse } from "axios";
import { getData } from "./apiInstance";
import { ProfitLossPayload } from "../commonTypes/insightAdvancedTypes";

export async function getInsightApi(data: any): Promise<AxiosResponse> {
  const { type, client_code, token, start_FY, end_FY } = data;
  return await getData(`report-module/monthly-ledger-report`, {
    params: {
      client_code,
      type,
      start_FY,
      end_FY,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getProfitLossApi(
  data: ProfitLossPayload
): Promise<AxiosResponse> {
  const { client_code, token, FY } = data;

  return await getData(`report-module/monthly-profit-loss-report`, {
    params: {
      client_code,
      FY,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
